import * as React from 'react';
import { pathOr } from 'ramda';

import { Preloader } from '@cian/preloader-component';
import { mergeStyles } from '@cian/utils';

import { getFormattedPhoneNumber } from '../../../../../utils/format';
import { IPhone } from '../../../../../types/offer';

import * as styles from './PhoneNumbers.css';

export interface IPhoneNumbersProps {
  phones: IPhone[];
  isSimplified: boolean;
  warningMessage: React.ReactNode;
  workTime?: React.ReactNode;
}

export function PhoneNumbers({ phones, isSimplified, warningMessage, workTime }: IPhoneNumbersProps) {
  return (
    <div
      {...mergeStyles([
        styles['text'],
        isSimplified && styles['simplified-text'],
        phones.length > 1 && styles['multiple-phones'],
      ])}
    >
      {phones.map((phone, index, array) => {
        return (
          <>
            <PhoneRenderer key={index} phone={phone} />
            {array.length - 1 !== index && <br/>}
          </>
        );
      })}
      {workTime}
      {warningMessage}
    </div>
  );
}

export interface IPhoneRendererProps {
  phone: IPhone;
}

export function PhoneRenderer({ phone }: IPhoneRendererProps) {
  return (
    pathOr(null, ['number'], phone)
      ? (<FormattedPhone phone={phone} />)
      : (<PhonePreloader />)
  );
}

export interface IFormattedPhoneProps {
  phone: IPhone;
}

export function FormattedPhone({ phone }: IFormattedPhoneProps) {
  return <span>{getFormattedPhoneNumber(phone)}</span>;
}

export function PhonePreloader() {
  return <span className={styles['preloader']}><Preloader size={16}/></span>;
}
